"use client"

import { routing } from "@/i18n/routing"
import { getLocalizedHref } from "@/lib/locale-utils"
import Link from "next/link"
import { useParams } from "next/navigation"
import React from "react"

interface PostLinkProps {
  href: string
  /** @deprecated Không còn dùng: lượt xem được đếm ở trang chi tiết (PostDetailContent). */
  postId?: number | string
  /**
   * Locale của chính bài viết (post.attributes.locale). Slug thuộc locale nào thì
   * URL phải theo locale đó → ưu tiên giá trị này; fallback về locale trên URL.
   */
  locale?: string
  className?: string
  children: React.ReactNode
}

const PostLink: React.FC<PostLinkProps> = ({ href, locale, className, children }) => {
  const params = useParams()
  const currentLocale = locale || (params?.locale as string) || routing.defaultLocale
  // as-needed: default (vi) không prefix, /en /cs được thêm prefix. Không đụng
  // href đã tuyệt đối (http) hoặc anchor "#".
  const localizedHref =
    href.startsWith("http") || href.startsWith("#") ? href : getLocalizedHref(currentLocale, href)
  return (
    <Link href={localizedHref} className={className}>
      {children}
    </Link>
  )
}

export default PostLink
